

function SearchTabClickWireUp()
{
  document.getElementById('search-results-tabs-form').addEventListener('submit', function (event) {
    event.preventDefault(); // Prevent default form submission


    SearchShowLoader();
    
    const clickedButton = event.submitter; 
    const buttonValue = clickedButton.value; 
    const targetTab =  clickedButton.getAttribute('targetTab');
    const targetResults = clickedButton.getAttribute('targetResults');
  
    //console.log(`Button pressed with value: ${buttonValue} | targetTab = ${targetTab}`);

    const targetResultElement = document.querySelector(`#${targetResults}`);
    const resultsContainerElements = document.querySelectorAll('.search-results-container');
    const tabElements = document.querySelectorAll('.search-results-tab');
    const selectedTabElement = document.querySelector(`.${targetTab}`);
    tabElements.forEach(element => element.classList.remove("search-results-tab-selected"));
    selectedTabElement.classList.add("search-results-tab-selected");

    resultsContainerElements.forEach(element => element.style.display="none");
    resultsContainerElements.forEach(element => element.classList.add("hidden"));




    if(targetResults == "collections-results")
    {
      SearchLoadCollectionResults(targetResultElement);
      UpdateSearchQueryType("cat");
      document.querySelector('.search-no-results-search-tab-type').innerHTML = "collection";
    }
    else if(targetResults == "content-results")
    {
      SearchLoadContent(targetResultElement);
      UpdateSearchQueryType("rec");
      document.querySelector('.search-no-results-search-tab-type').innerHTML = "resource";
    }
    else
    {
      SearchHideLoader();
      UpdateSearchQueryType("prod");
      SearchResultHandleCount(targetResultElement);
      document.querySelector('.search-no-results-search-tab-type').innerHTML = "product";
    }
  });



  document.querySelector('#Search-Inline-No-Search-Results-Query').addEventListener('input', ShowNoResultsClear);


  setTimeout(SearchResultScrollToTop, 100);
  
}

function SearchResultScrollToTop()
{

  //console.log("SearchResultScrollToTop");
  
  var searchScrollToOnLoadElement = document.querySelector('.search-results-header-container'); 

  window.scrollTo({
    top: 0 
  });
}

function SearchResultHandleCount(targetResultElement)
{
  var resultCount = targetResultElement.getAttribute('result-count');

  //console.log("resultCount = " + resultCount);

  if(resultCount > 0)
  {
    targetResultElement.style.display = "block";
    targetResultElement.classList.remove("hidden");
    document.querySelector('.search-no-results-search-container').classList.add("hidden");

    if(document.querySelector('.nw-slider-with-cta-v3') != null)
    {
    document.querySelector('.nw-slider-with-cta-v3').style.display="none";
    }

    SearchResultsUpdateProductCounts();
  }
  else
  {

    
    document.querySelector('.search-no-results-search-container').classList.remove("hidden");
    if(document.querySelector('.nw-slider-with-cta-v3') != null)
    {
      document.querySelector('.nw-slider-with-cta-v3').style.display="block";
      const slider = document.querySelector('.nw-slider-with-cta-v3');
      (new Slider(slider)).initialize();
    }
  }
}

function SearchResultsUpdateProductCounts()
{
  //console.log("SearchResultsUpdateProductCounts Update");
  var productPageCount = document.querySelector('#product-search-results-size').value;
  var productTotalCount = document.querySelector('#product-search-results-total').value;

  // only set if found
  document.querySelector('#product-search-results-page-count').innerHTML = productPageCount;

  if(productPageCount != productTotalCount)
    document.querySelector('#product-search-results-total-count').innerHTML = ' of ' + productTotalCount;
}

function SearchNoResultsClear(elementIdToClear)
{
  document.querySelector('#'+elementIdToClear).value = "";
}


function ShowNoResultsClear()
{
  var inputTextLength = document.querySelector('#Search-Inline-No-Search-Results-Query').value.length;

  //console.log('inputTextLength = ' + inputTextLength);
  
  if(inputTextLength > 0)
    document.querySelector('.search-no-results-clear').classList.remove("hidden");
  else
    document.querySelector('.search-no-results-clear').classList.add("hidden");
}

function SearchShowLoader()
{
    document.querySelector('.search-results-loading').classList.remove("hidden");
}
function SearchHideLoader()
{
    document.querySelector('.search-results-loading').classList.add("hidden");
}

function SearchLoadAppropriateTab()
{
  const searchTabTarget = new URLSearchParams(window.location.search).get("tab");
  //console.log('target tab = ' + searchTabTarget);

  if(searchTabTarget=="cat")
  {
    document.querySelector('.search-results-tab-collections button')?.click();

  }
  else if(searchTabTarget=="rec")
  {
    document.querySelector('.search-results-tab-content button')?.click();

  }
  else if(searchTabTarget=="prod")
  {
    document.querySelector('.search-results-tab-products button')?.click();

  }
  else
  {
    document.querySelector('.search-results-tab-products button')?.click();
  }
}

function SearchLoadCollectionResults(targetResultElement)
{
  
    const searchQueryValue = new URLSearchParams(window.location.search).get("q");
    var searchurl = routes.predictive_search_url + ".json?q="+searchQueryValue+"&resources[type]=collection&resources[limit]=20&resources[options][fields]=title,product_type,variants.title,tag,variants.title,variants.sku,body";

    fetch(searchurl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(data => {
      //console.log("data results = " + JSON.stringify(data));
      SearchRenderCollectionResults(data, targetResultElement);

    })
    .catch(err => {
        console.error('Error fetching suggestions:', err);
    });
}

function SearchRenderCollectionResults(data,targetResultElement)
{

  document.querySelector('.search-collection-results-count').innerHTML = data.resources.results.collections.length;
  targetResultElement.setAttribute('result-count',data.resources.results.collections.length);
  
  //search-collection-result-item-template
  const collectionResultTemplate = document.getElementById('search-collection-result-item-template');
  const collectionResultsContainer = document.querySelector('.search-collection-results-items');


  collectionResultsContainer.replaceChildren();
  
  for (const nextCollection of data.resources.results.collections) {
    //console.log("Next Collection Title = " + nextCollection.title);
    var nextCollectionClone = collectionResultTemplate.content.cloneNode(true);
    nextCollectionClone.querySelector('.search-collection-result-title-inner').textContent = nextCollection.title;
    nextCollectionClone.querySelector('.search-collection-result-description').innerHTML  = nextCollection.body;
    nextCollectionClone.querySelector('.search-collection-result-item').href  = nextCollection.url;
    collectionResultsContainer.appendChild(nextCollectionClone);
  }


  SearchResultHandleCount(targetResultElement);
  
  SearchHideLoader();

}

async function SearchLoadContent(targetResultElement)
{
  //https://natureswaydev-joshdevfeature.myshopify.com/search?type=product&q=sambucus&options%5Bprefix%5D=last


  const searchQueryValue = new URLSearchParams(window.location.search).get("q");
  var searchurl = "/search?type=page,article&q="+searchQueryValue+"&options%5Bprefix%5D=last";

  try {
    const response = await fetch(searchurl); // Ensure this fetches HTML
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const html = await response.text(); // Convert response body to text
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const jsonElement = doc.getElementById("json-data-search-results");


    
    if (jsonElement) {
      //console.log(jsonElement.textContent);
      const jsonData = JSON.parse(jsonElement.textContent);
      //console.log(jsonData);

      
      targetResultElement.setAttribute('result-count',jsonData.length);
      SearchRenderContentResults(jsonData,'article',targetResultElement);
      SearchRenderContentResults(jsonData,'page',targetResultElement);

      const pagesTotals = document.querySelector('.search-content-results-pages .search-content-results-items').children.length;
      const articlesTotals = document.querySelector('.search-content-results-blogs .search-content-results-items').children.length;

      const contentTotals = pagesTotals + articlesTotals;
      
      document.querySelector('.search-content-results-count').innerHTML = contentTotals;
      SearchResultHandleCount(targetResultElement);
    } else {
      throw new Error(`Element with ID "${elementId}" not found.`);
    }
  } catch (error) {
    console.error("Error fetching or parsing JSON:", error);
  }
}

function SearchRenderContentResults(data, filterType)
{
  //search-collection-result-item-template
  const contentResultTemplate = document.getElementById('search-content-result-item-template');

  var contentResultsContainer = "";
  
  if(filterType == 'article')
  {
    contentResultsContainer = document.querySelector('.search-content-results-blogs .search-content-results-items');
  }
  else
  {
    contentResultsContainer = document.querySelector('.search-content-results-pages .search-content-results-items');
  }
  


  contentResultsContainer.replaceChildren();

  var resultCount = 0;


  //console.log(searchSettingsPageExclusionArray);
  
  for (const nextContent of data) {
    if(nextContent.object_type != filterType)
      continue;

    if(searchSettingsPageExclusionArray.includes(Number(nextContent.id)))
    {
      console.log('skipping id = ' + nextContent.id);
      continue;
    }
    
    //console.log("Next Collection Title = " + nextContent.title + " nextContent.object_type = " + nextContent.object_type + " nextContent.id = " + nextContent.id);
    var nextContentClone = contentResultTemplate.content.cloneNode(true);
    nextContentClone.querySelector('.search-content-result-title').innerHTML = nextContent.title;
    nextContentClone.querySelector('.search-content-result-item').href = nextContent.url;
    nextContentClone.querySelector('.search-content-result-date').innerHTML = nextContent.published_at;
    
    if(nextContent.image_src != null)
    {
      nextContentClone.querySelector('.search-content-result-image img').src = nextContent.image_src + "&height=400";
    }
    if(nextContent.object_type == "article" && nextContent.tags != null && nextContent.tags.length > 0)
    {
      nextContentClone.querySelector('.search-content-result-badge').classList.remove('hidden');
      nextContentClone.querySelector('.search-content-result-badge-inner').innerHTML = nextContent.tags[0];
      
    }
    else
    {
      nextContentClone.querySelector('.search-content-result-badge').classList.add('hidden');
    }

    if(nextContent.object_type == "article")
    {
      nextContentClone.querySelector('.search-content-result-desc').classList.add('hidden');
    }
    else
    {
      if(nextContent.description_tag != null)
        nextContentClone.querySelector('.search-content-result-desc').innerHTML = nextContent.description_tag;
      nextContentClone.querySelector('.search-content-result-date').classList.add('hidden');
      //nextContentClone.querySelector('.search-content-result-desc').classList.add('hidden');
      nextContentClone.querySelector('.search-content-result-image').classList.add('hidden');
      nextContentClone.querySelector('.search-content-result-item').classList.add('search-content-result-item-page');
    }
    
    contentResultsContainer.appendChild(nextContentClone);
    resultCount++;
  }

  if(resultCount > 0)
  {
    if(filterType == 'article')
    {
      document.querySelector('.search-content-results-blogs').classList.remove('hidden');
    }
    else
    {
      document.querySelector('.search-content-results-pages').classList.remove('hidden');
    }
  }

  SearchHideLoader();
}

function UpdateSearchQueryType(value) {
  const url = new URL(window.location.href);
  url.searchParams.set("tab", value);
  window.history.replaceState(null, "", url);

  document.querySelector('#Search-Inline-No-Search-Results-Type').value = value;

}


function SearchResultsProductOnElementChanged(mutationsList, observer) {
    //console.log("Element structure changed!");
    SearchResultsUpdateProductCounts();
}

function SearchResultsProductMonitorForMutations()
{
  let targetElement = document.querySelector("#ProductGridContainer");
  if (targetElement) {
      let observer = new MutationObserver(SearchResultsProductOnElementChanged);
  
      let config = {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
      };
  
      observer.observe(targetElement, config);
  } else {
      //console.log("Target element not found.");
  }
}


document.addEventListener('DOMContentLoaded', function() {
  SearchTabClickWireUp();
  SearchLoadAppropriateTab();
  SearchResultsProductMonitorForMutations();
});